<template>
    <v-container>
        <v-layout column>
            <config-expiracao-lead />
        </v-layout>
    </v-container>
</template>

<script>
import ConfigExpiracaoLead from './ConfigExpiracaoLead'

export default {
  components: { ConfigExpiracaoLead }
}
</script>

<style scoped>

</style>
